import React from 'react'

const defaultSize = 56

// eslint-disable-next-line react/prop-types
const Icon = ({ size = defaultSize }) =>
  <svg
    width={size}
    height={size}
    viewBox='0 0 80 80'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M4.05453 73.5173L16.3314 73.5173C17.7015 73.5173 18.9786 72.8242 19.7253 71.6755L36.0741 46.5234L30.1987 37.4844C27.8043 33.8007 22.4114 33.8007 20.017 37.4844L0.660633 67.2634C-1.08971 69.9562 0.84281 73.5173 4.05453 73.5173Z' fill='#CB2233' />
    <path d='M31.8835 73.5173L44.1604 73.5173C45.5305 73.5173 46.8076 72.8242 47.5543 71.6755L63.9031 46.5235L58.0277 37.4844C55.6333 33.8007 50.2403 33.8007 47.846 37.4844L28.4896 67.2634C26.7393 69.9562 28.6718 73.5173 31.8835 73.5173Z' fill='#CB2233' />
    <path d='M78.4796 73.6647H65.1259C61.7351 73.6647 58.5675 71.9745 56.6798 69.1578C56.256 68.5256 56.249 67.7019 56.6617 67.0625L65.5025 53.3677C66.0988 52.4439 67.4491 52.4409 68.0495 53.3622L79.7513 71.318C80.4093 72.3277 79.6848 73.6647 78.4796 73.6647Z' fill='url(#paint0_linear)' />
    <circle cx='24.8724' cy='14.2996' r='10.9662' fill='#CB2233' />
    <ellipse cx='51.8568' cy='14.2996' rx='10.9662' ry='10.9662' fill='#CB2233' />
    <defs>
      <linearGradient id='paint0_linear' x1='69.1528' y1='65.2498' x2='62.6822' y2='59.0831' gradientUnits='userSpaceOnUse'>
        <stop stopColor='#CB2233' />
        <stop offset='1' stopColor='#910000' />
      </linearGradient>
    </defs>
  </svg>

export default Icon
